/**
 * Outreach widget registry — name → React component. Schemas come from
 * @rmint/widgets/registry (shared contract). Supplied to the @rmint/shell
 * markdown renderer via WidgetRegistryProvider in main.tsx.
 */
import type { WidgetComponent } from '@rmint/shell';
import { widgetRegistry as schemaRegistry, type WidgetName } from '@rmint/widgets/registry';
import { ResearchFindingCard } from './research-finding';
import { CandidateCard } from './candidate-card';
import { ProspectLink } from './prospect-link';
import { DraftCard } from './draft-card';
import { FounderDecision } from './founder-decision';
import { TodayQueue } from './today-queue';
import { InboxDecisions } from './inbox-decisions';
import { PipelineView } from './pipeline-view';
import { FeedSignals } from './feed-signals';
import { ConversationsList } from './conversations-list';
import { SourcesList } from './sources-list';
import { TemplatesList } from './templates-list';
import { WorkersList } from './workers-list';
import { SequencesList } from './sequences-list';
import { SequenceGraphWidget } from './sequence-graph';
import { DevicePairing } from './device-pairing';

export type { WidgetProps, WidgetComponent } from '@rmint/shell';

const components: Partial<Record<WidgetName, WidgetComponent>> = {
  'research-finding': ResearchFindingCard as unknown as WidgetComponent,
  'candidate-card': CandidateCard as unknown as WidgetComponent,
  'prospect-link': ProspectLink as unknown as WidgetComponent,
  'draft-card': DraftCard as unknown as WidgetComponent,
  'founder-decision': FounderDecision as unknown as WidgetComponent,
  'today-queue': TodayQueue as unknown as WidgetComponent,
  'inbox-decisions': InboxDecisions as unknown as WidgetComponent,
  'pipeline-view': PipelineView as unknown as WidgetComponent,
  'feed-signals': FeedSignals as unknown as WidgetComponent,
  'conversations-list': ConversationsList as unknown as WidgetComponent,
  'sources-list': SourcesList as unknown as WidgetComponent,
  'templates-list': TemplatesList as unknown as WidgetComponent,
  'workers-list': WorkersList as unknown as WidgetComponent,
  'sequences-list': SequencesList as unknown as WidgetComponent,
  'sequence-graph': SequenceGraphWidget as unknown as WidgetComponent,
  'device-pairing': DevicePairing as unknown as WidgetComponent,
};

export const widgetRegistry: Record<string, WidgetComponent> = { ...components };
export { schemaRegistry };
